import { connect } from 'react-redux';
import BillAnnotationFromSelection from '../components/BillAnnotationFromSelection';
import { getSelectedTeamIds, openEditUserActionModal } from '../dux';

const mapStateToProps = (state) => {
  return {
    userSelectedTeams: getSelectedTeamIds(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openEditUserActionModal: (userAction) => {
      dispatch(openEditUserActionModal(userAction));
    },
  };
};

const BillDetailsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(BillAnnotationFromSelection);

export default BillDetailsContainer;
